import { render, staticRenderFns } from "./SwitchWindow.vue?vue&type=template&id=0818d7c4&"
import script from "./SwitchWindow.vue?vue&type=script&lang=js&"
export * from "./SwitchWindow.vue?vue&type=script&lang=js&"
import style0 from "./SwitchWindow.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports